import type { ReactNode } from "react";
import styled from "styled-components";
import { UserApplicationDataResponse } from "@songtradr-sso/shared/common";
import { primary03, shade0 } from "@songtradr/design-language";
import { staticText } from "../../../statics/static-text";
import { Row } from "../Row.Parts";

// TEXT
export const text = staticText.components.row.appRow;

// STYLES
export const StretchedLink = styled.a`
  white-space: nowrap;
  transition: color 200ms ease;

  &::after {
    content: "";
    position: absolute;
    inset: 0;
  }
`;

export const LogoSlot = styled.span<LogoSlotProps>`
  display: block;
  min-width: 0;
  background-color: ${shade0};
  mask: url("${({ $src }) => $src}") left center / contain no-repeat;
  transition: background-color 200ms ease;

  ${Row}:has(a:hover) & {
    background-color: ${primary03};
  }

  img {
    display: block;
    height: 28px;
    max-width: 100%;
    object-fit: contain;
    opacity: 0;
  }
`;

// DATA

// TYPES
export type Props = {
  data: UserApplicationDataResponse;
  /** Optional action element rendered at the end of the row */
  action?: ReactNode;
};

export type LogoSlotProps = { $src: string };

// CONSTANTS

// FUNCTIONS
export const getRolesText = (roles?: string[]) =>
  roles?.map((role) => role).join(", ") || text.noRoles;

// ASSETS
